import { RootStore } from '@/stores/root-store.types';
import { StoreApi } from 'zustand';

export const createModalsSlice = (
  set: StoreApi<RootStore>['setState'],
  get: StoreApi<RootStore>['getState'],
  ...rest: StoreApi<RootStore>[]
) => ({});
